import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import root from 'window-or-global';

const ShardParticles = ({active, amount}) => {
    const canvasEl = useRef();

    const backgroundParticles = (canvas, amount) => {
        if (typeof canvas.getContext === 'undefined') return;

        const ctx = canvas.getContext('2d');
        const elements = [];
        const presets = {};
        const resize = function () {
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;
        };

        root.addEventListener('resize', resize);
        resize();

        //drawing the shard
        presets.shard = function (x, y, random, color) {
            return {
                x,
                y,
                draw: function (ctx, t) { // eslint-disable-line
                    this.x += 0;
                    this.y += 0;
                    const posX = this.x + +Math.sin((50 + x + (t / 10)) / 100) * 5;
                    const posy = this.y + +Math.sin((55 + x + (t / 10)) / 100) * 7;
                    ctx.beginPath();
                    ctx.fillStyle = `rgba(${color})`;
                    ctx.moveTo(posX, posy);
                    ctx.lineTo(posX + random, posy + random);
                    ctx.lineTo(posX + random, posy + random);
                    ctx.lineTo(posX + 0, posy+40);
                    ctx.closePath();
                    ctx.fill();
                }
            }
        };

        for (let i = 0; i < amount; i++) {
            const random = Math.floor(Math.random() * 60) + 10;
            const opacityRange = ['0.3', '0.7', '1'];
            const opacity = opacityRange[Math.floor(Math.random() * opacityRange.length)];
            const colorRange = [`157,153,151,${opacity}`, `156,153,149,${opacity}`];
            const color = colorRange[Math.floor(Math.random() * colorRange.length)];
            const x = Math.random() * canvas.width;
            const y = Math.random() * canvas.height;

            elements.push(presets.shard(x, y, random, color));
        }

        setInterval(() => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const time = new Date().getTime();
            for (const e in elements) {
                if (e) elements[e].draw(ctx, time);
            }
        }, 10);
    }

    useEffect(() => {
        backgroundParticles(canvasEl.current, amount);
    }, [])

    return (
        <canvas className={classNames('shard-particles', active && 'active')} ref={canvasEl} />
    )
};

ShardParticles.propTypes = {
    active: PropTypes.bool,
    amount: PropTypes.number
};

ShardParticles.defaultProps = {
    active: false,
    amount: 20
};

export default ShardParticles;
